import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loadingState } from "src/atom/LoadingState";
import { useRecoilState } from "recoil";
import { alertMessageState } from "src/atom/LoadingState";
import {
  getCategory,
  raiseTicket,
  getSubCategory,
} from "src/services/Ticketing/StudentTicketService";

export default function RaiseTicket() {
  const ticketObject = {
    title: "",
    type: "technical",
    ticketCategoryId: "",
    subCategoryId: "",
    query: "",
  };

  const reset = async (e) => {
    setFormData({
      title: "",
      type: "",
      ticketCategoryId: "",
      subCategoryId: "",
      query: "",
    });
  };

  const [, setIsSubmitted] = useState(false);
  const [, enableLoader] = useRecoilState(loadingState);
  const [formData, setFormData] = useState(ticketObject);
  const [, setLoading] = useState(false);
  const [allcategory, setCategory] = useState([]);
  const [ticketSubCategory, setTicketSubCategory] = useState([]);
  const [, setAlertMessage] = useRecoilState(alertMessageState);
  const [, setTicketType] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  const [validationErrors, setValidationErrors] = useState({
    title: "",
    regNumber: "",
    ticketCategory: "",
    subCategoryId: "",
    query: "",
    files: "",
  });

  const validateForm = () => {
    let errors = {};
    let isValid = true;

    if (!formData.title) {
      errors.title = "Please provide a ticket title.";
      isValid = false;
    }
    if (!formData.ticketCategoryId) {
      errors.category = "Please select a ticket category.";
      isValid = false;
    }
    if (!formData.subCategoryId) {
      errors.subCategoryId = "Please select a ticket subcategory.";
      isValid = false;
    }
    if (!formData.query) {
      errors.query = "Please provide a ticket description.";
      isValid = false;
    }
    if (!selectedFile) {
      errors.ticketAttachment = "Please select a file.";
      isValid = false;
    }

    setValidationErrors(errors);
    return isValid;
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    const isValid = validateForm();
    if (isValid) {
      enableLoader(true);
      const formValues = new FormData();
      if (selectedFile !== undefined) {
        formValues.append("files", selectedFile);
      }
      formValues.append("ticket", JSON.stringify(formData));
      setValidationErrors({});
      setLoading(true);
      try {
        const response = await raiseTicket(formValues);
        if (response.success) {
          setAlertMessage(response?.body + "|true");
          setFormData(ticketObject);
          setSelectedFile(null);
          enableLoader(false);
        } else {
          enableLoader(false);
          setAlertMessage(response.message);
        }
      } catch (error) {
        console.error("Error raising ticket:", error);
      } finally {
        enableLoader(false);
        setLoading(false);
      }
      navigate("/all-tickets");
    }
  };

  const handleTicketCategoryChange = (e) => {
    if (e.target.value) {
      fetchSubCategory(e.target.value);
    } else {
      setTicketType("");
      setTicketSubCategory("");
    }
    setFormData((formData) => ({
      ...formData,
      ["subCategoryId"]: "",
      [e.target.name]: e.target.value,
    }));
  };

  const handleTicketSubCategoryChange = (e) => {
    setFormData((formData) => ({
      ...formData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    if (e.target.files) {
      const file = e.target.files[0];
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
      ];
      if (!allowedTypes.includes(file.type)) {
        setValidationErrors((errors) => ({
          ...errors,
          [e.target.id]:
            "Invalid file type. Please select a JPG, JPEG, PNG or PDF file.",
        }));
        e.target.value = "";
        return;
      }
      setSelectedFile(file);
      setValidationErrors((errors) => ({
        ...errors,
        [e.target.id]: "",
      }));
    }
  };

  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/all-tickets");
  };

  const fetchCategory = async () => {
    enableLoader(true);
    const fetchAllCategory = async () => {
      enableLoader(false);
      var response = await getCategory();
      if (response.success) {
        setCategory(response.body);
        enableLoader(false);
      } else {
        enableLoader(false);
        setAlertMessage(response.message);
      }
    };
    fetchAllCategory();
  };

  const fetchSubCategory = async (categoryId) => {
    enableLoader(true);
    const fetchAllSubCategory = async (categoryId) => {
      enableLoader(false);
      var response = await getSubCategory(categoryId);
      if (response.success) {
        setTicketSubCategory(response.body);
        enableLoader(false);
      } else {
        enableLoader(false);
        setAlertMessage(response.message);
      }
    };
    fetchAllSubCategory(categoryId);
  };

  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <div className="card">
          <div
            className="card-header text-white d-flex align-items-center justify-content-between"
            style={{ backgroundColor: "#3C4B64" }}
          >
            <span className="mr-auto">Raise Grievance</span>
            <button
              className="btn btn-light btn-sm"
              onClick={() => {
                handleButtonClick();
              }}
            >
              All Tickets
            </button>
          </div>
          <div className="card-body ">
            <form>
              <div className="row mb-2">
                <div className="col-md-3 mb-2 ms-5">
                  <label htmlFor="totalSeats">Ticket Title</label>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className={`form-control ${
                        validationErrors.title ? "is-invalid" : ""
                      }`}
                      id="title"
                      placeholder="Enter Ticket Title"
                      name="title"
                      value={formData?.title}
                      onChange={handleInputChange}
                    />
                    {validationErrors.title && (
                      <div className="invalid-feedback">
                        {validationErrors.title}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3 mb-2 ms-5">
                  <label htmlFor="totalSeats">Ticket Category</label>
                </div>
                <div className="col-md-6 ">
                  <div className="form-group">
                    <select
                      name="ticketCategoryId"
                      value={formData?.ticketCategoryId}
                      onChange={(e) => {
                        handleTicketCategoryChange(e);
                      }}
                      className={`form-control ${
                        validationErrors.category ? "is-invalid" : ""
                      }`}
                      id="ticketCategory"
                    >
                      <option value="">Select Category</option>
                      {allcategory?.map((result) => (
                        <option key={result.id} value={result.id}>
                          {result.category}
                        </option>
                      ))}
                    </select>

                    {validationErrors.category && (
                      <div className="invalid-feedback">
                        {validationErrors.category}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3 mb-2 ms-5">
                  <label htmlFor="totalSeats">Ticket SubCategory</label>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <select
                      name="subCategoryId"
                      value={
                        formData?.subCategoryId ? formData.subCategoryId : ""
                      }
                      onChange={(e) => {
                        handleTicketSubCategoryChange(e);
                      }}
                      className={`form-control ${
                        validationErrors.subCategoryId ? "is-invalid" : ""
                      }`}
                      id="subCategoryId"
                    >
                      <option value="">Select Sub Category</option>
                      {ticketSubCategory &&
                        ticketSubCategory?.map((result) => (
                          <option key={result.id} value={result.id}>
                            {result.category}
                          </option>
                        ))}
                    </select>
                    {validationErrors.subCategoryId && (
                      <div className="invalid-feedback">
                        {validationErrors.subCategoryId}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3 mb-2 ms-5">
                  <label htmlFor="email">Ticket Description</label>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <textarea
                      rows="6"
                      cols="50"
                      className={`form-control ${
                        validationErrors.query ? "is-invalid" : ""
                      }`}
                      id="query"
                      placeholder="Please describe your ticket"
                      name="query"
                      value={formData?.query}
                      onChange={handleInputChange}
                    />
                    {validationErrors.query && (
                      <div className="invalid-feedback">
                        {validationErrors.query}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3 mb-2 ms-5">
                  <label>Attachment</label>
                </div>
                <div className="col-md-6">
                  <input
                    type="file"
                    id="ticketAttachment"
                    multiple={false}
                    onChange={handleFileChange}
                    className={`form-control ${
                      validationErrors.ticketAttachment ? "is-invalid" : ""
                    }`}
                  />
                  {validationErrors.ticketAttachment && (
                    <div className="invalid-feedback">
                      {validationErrors.ticketAttachment}
                    </div>
                  )}
                </div>
              </div>
              <div className="mt-5 d-flex justify-content-center">
                <button
                  type="button"
                  className="btn btn-sm btn-success text-white me-3"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
                <button
                  type="reset"
                  className="btn btn-sm btn-warning text-white"
                  onClick={reset}
                >
                  Reset
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
